import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input
} from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { DatePipe, DecimalPipe } from "@angular/common";
import { Store } from "@ngrx/store";
import { selectStudentById } from "src/app/students/ngrx/students.selectors";

@Component({
    selector: "app-invoice-item",
    templateUrl: "./invoice-item.component.html",
    styleUrls: ["./invoice-item.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IonicModule, DatePipe, DecimalPipe]
})
export class InvoiceItemComponent {
  constructor(private store: Store<any>) {}

  readonly invoiceId = input<number>(undefined);
  public today = new Date();
  invoiceSignal = this.store.selectSignal(
    (state) => state.invoices.entities[this.invoiceId()]
  );
  studentSignal = computed(() =>
    this.store.selectSignal(
      selectStudentById(this.invoiceSignal()?.student_id)
    )()
  );

  convertToDate(dateString) {
    return new Date(dateString);
  }
}
